module.exports = __webpack_public_path__ + "static/media/send-button.292be3f0.svg";